import VueRouter from 'vue-router';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { RouteName } from '../../../routes/routes.constants';
import { getUserJurisdiction } from '../helpers/jurisdiction.helpers';
import { magic } from '@gig/magic-sdk';
import { isRouteActive } from '../helpers/routes';
import {
    USER_REQUIRES_TERMS_ACCEPTANCE_QUERY,
    USER_UPDATE_PREFERENCES_UPDATED,
} from '@gig/magic-messages';
import { IUpdatedPreferencesEventPayload } from '@gig/magic-responsible-gaming-types';

export function initSGASetLimitsGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        const { params, query } = to;

        const user = magic.session.getUser();

        if (!user) {
            return next();
        }

        if (
            isRouteActive(RouteName.SIGN_UP_BANKID, to, router) ||
            isRouteActive(RouteName.USER_INFO, to, router)
        ) {
            return next();
        }

        if (!(await isSGA())) {
            return next();
        }
        const preferences =
            window.eventBus.getLatest<IUpdatedPreferencesEventPayload>(
                USER_UPDATE_PREFERENCES_UPDATED,
            );

        if (preferences?.preferences.limitsConfirmed) {
            return isRouteActive(RouteName.SET_LIMITS, to, router)
                ? next({ name: RouteName.HOME })
                : next();
        }

        if (isRouteActive(RouteName.SET_LIMITS, to, router)) {
            return next();
        }

        if (await hasPendingConsents()) {
            return next();
        }

        return next({
            name: RouteName.SET_LIMITS,
            params,
            query: { ...query, backTo: to.fullPath },
        });
    });
}

async function isSGA(): Promise<boolean> {
    return (await getUserJurisdiction()) === Jurisdiction.SGA;
}
function hasPendingConsents() {
    return window.queryBus.query<boolean>(USER_REQUIRES_TERMS_ACCEPTANCE_QUERY);
}
